var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Trash",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash-2",
    transform: "translate(3.000000, 2.000000)",
    stroke: "#000000",
    strokeWidth: 1.33333333
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 2.66666667 1.33333333 2.66666667 12 2.66666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,2.66666667 L10.6666667,12 C10.6666667,12.7363797 10.069713,13.3333333 9.33333333,13.3333333 L2.66666667,13.3333333 C1.930287,13.3333333 1.33333333,12.7363797 1.33333333,12 L1.33333333,2.66666667 M3.33333333,2.66666667 L3.33333333,1.33333333 C3.33333333,0.596953667 3.930287,0 4.66666667,0 L7.33333333,0 C8.069713,0 8.66666667,0.596953667 8.66666667,1.33333333 L8.66666667,2.66666667",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.66666667,
    y1: 6,
    x2: 4.66666667,
    y2: 10,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.33333333,
    y1: 6,
    x2: 7.33333333,
    y2: 10,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ededcda6b4649caa3a4e76940026455e.svg";
export { ForwardRef as ReactComponent };